/*global angular*/
(function ( ) {
	
	angular.module('vorm')
		.constant('VormValueType',{
			SINGLE: 'single',
			LIST: 'list',
			NAMED: 'named'
		});
	
})();
